"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateStory = void 0;
const migrations_1 = require("./migrations");
const getMigratedDialog = async (dialog, migration, verbose = false) => {
    var _a;
    verbose && console.info('getMigratedDialog', { dialog, migration });
    const migratedDialog = await migration.migrationFn(dialog);
    verbose && console.info('getMigratedDialog', migration.migrationFn.toString());
    verbose && console.info('getMigratedDialog', { migratedDialog });
    // From migrationV13 and schemaV2 on-ward
    if (!migratedDialog.version && ((_a = migratedDialog.metadata) === null || _a === void 0 ? void 0 : _a.version) >= 12) {
        return {
            ...migratedDialog,
            metadata: {
                ...migratedDialog.metadata,
                version: migration.version,
            }
        };
    }
    const dialogWithUpdatedVersion = {
        ...migratedDialog,
        lastVersion: undefined,
        version: migration.version.toString(),
    };
    if (dialogWithUpdatedVersion.metadata) {
        return {
            ...dialogWithUpdatedVersion,
            metadata: {
                ...dialogWithUpdatedVersion.metadata,
                version: migration.version,
            }
        };
    }
    else {
        return dialogWithUpdatedVersion;
    }
};
const getAvailableMigrations = (toVersion, currentVersion, verbose = false) => {
    if (verbose) {
        console.info('getAvailableMigrations', { toVersion, currentVersion });
    }
    const availableMigrations = [];
    const lastVersion = Number(toVersion);
    let nextVersion = currentVersion ? Number(currentVersion) + 1 : 1;
    while (nextVersion <= lastVersion) {
        availableMigrations.push({
            version: nextVersion,
            migrationFn: migrations_1.migrations[nextVersion]
        });
        nextVersion++;
    }
    verbose && console.info('getAvailableMigrations', { availableMigrations });
    return availableMigrations;
};
const migrateStory = async (dialog, toVersion, verbose = false) => {
    var _a, _b;
    verbose && console.info(`migrateDialog`, { toVersion });
    if (Number(toVersion) !== migrations_1.lastMigrationVersion) {
        console.warn(`Migrating dialog to a version (v${toVersion}) different than last (v${migrations_1.lastMigrationVersion}) available.`);
    }
    const hasMigration = migrations_1.migrations[toVersion];
    verbose && console.info(`migrateDialog`, { hasMigration, migrations: migrations_1.migrations });
    if (!hasMigration) {
        throw new Error(`Could not find migration for version: '${toVersion}'`);
    }
    if (toVersion === dialog.version) {
        verbose && console.info(`Dialog already up to date. Skip migration.`);
        return dialog;
    }
    const currentVersion = dialog.version ? dialog.version.toString() : (_b = (_a = dialog.metadata) === null || _a === void 0 ? void 0 : _a.version) === null || _b === void 0 ? void 0 : _b.toString();
    const availableMigrations = getAvailableMigrations(toVersion.toString(), currentVersion, verbose);
    if (availableMigrations.length === 0) {
        verbose && console.info(`No available migrations. Return same input dialog`);
        return dialog;
    }
    let finalDialog = JSON.parse(JSON.stringify(dialog));
    for (const migration of availableMigrations) {
        finalDialog = await getMigratedDialog(finalDialog, migration, verbose);
    }
    verbose && console.info('migrateDialog', { finalDialog });
    return finalDialog;
};
exports.migrateStory = migrateStory;
//# sourceMappingURL=migrateDialog.js.map